// extracted by mini-css-extract-plugin
export default {"banner":"ImpersonationBanner_banner__tVAfR"};